import ActionTypes from "../constants/action_types";

export default function clearUser() {
  return {
    type: ActionTypes.USER_CLEAR.SUCCESS,
  };
}
